import type { ReactNode } from 'react';

interface BackupCodesProps {
  codes: string[];
  userId?: string;
  /** The button that closes the list, e.g. "Continue" or "I have saved them". */
  children?: ReactNode;
}

/** The one-time backup codes, shown once, with download and copy. */
export function BackupCodes({ codes, userId, children }: BackupCodesProps) {
  const download = () => {
    const text =
      `Sabre Agency Workspace backup codes for ${userId ?? ''}\n` +
      'Each code can be used once instead of an authenticator code.\n\n' +
      codes.join('\n') +
      '\n';
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'sabre-backup-codes.txt';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <p className="field-hint">
        If you lose your phone, each of these codes signs you in once. Keep them somewhere safe. They are shown only
        now.
      </p>
      <ul className="security-codes mono">
        {codes.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ul>
      <div className="security-actions">
        <button type="button" className="spark-btn spark-btn--secondary" onClick={download}>
          Download codes
        </button>
        <button
          type="button"
          className="spark-btn spark-btn--secondary"
          onClick={() => void navigator.clipboard?.writeText(codes.join('\n'))}
        >
          Copy codes
        </button>
        {children}
      </div>
    </>
  );
}
